<template>
  <div>
    <div class="btn-form-filtros-avancados">
      <p @click="abreFiltros">Filtros avançados</p>
      <font-awesome-icon class="icon-filter" :icon="['fas', 'filter']" @click="abreFiltros" />
      <div class="botao-relatorio-container">

        <BotaoPadrao
          arredondadoEsquerda
          class="botao-padding"
          nome="GERAR RELATÓRIO"
          icone="file-download"
         v-b-modal="'ModalRelatorio'"
          cor="azul"
        />
        <router-link to="/monitoria-produto">
          <BotaoPadrao
            arredondadoEsquerda
            class="botao-padding"
            nome="PRODUTOS MONITORADOS"
            icone="chevron-left"
            cor="azul"
          />
        </router-link>
      </div>

    </div>
    <div class="form-filtros">
      <i>
        <font-awesome-icon icon="search" />
      </i>
      <CenarioInput
        placeholder="Pesquisar em Produtos"
        class="input-pesquisar"
        tipo="texto"
        :model="strPesquisa"
        :disabled="blFiltros"
        @update:model="update => (strPesquisa = update)"
      />

      <div class="intervalo-tempo">
        <font-awesome-icon
          class="icon-inside-input"
          icon="calendar"
          v-b-tooltip.hover
          title="Data de Alteração"
        />

        <datepicker
          class="input-filtros"
          v-model="de"
          :disabled-dates="disabledDatesAfterDe"
          range-separator=" de "
          :format="'dd/MM/yyyy'"
          :language="pt"
          placeholder="De"
        ></datepicker>
        <datepicker
          class="input-filtros"
          v-model="ate"
          :disabled-dates="disabledDatesBeforeAte"
          :format="'dd/MM/yyyy'"
          :language="pt"
          range-separator=" até "
          placeholder="Até"
        ></datepicker>
        <button class="btn-limpar" v-if="de || ate" @click="clearDe">X</button>
      </div>
    </div>
    <transition name="fade">
      <div class="form-filtros-avancados" v-if="blFiltros">
        <CenarioInput
          class="avancado-input"
          placeholder="Selecione o Produto"
          nome="produto"
          :model="nomeProduto"
          :disabled="form.ncm != '' ? true : false"
          :options="produto"
          @update:model="update => (nomeProduto = update)"
          @selected="update => (form.nome_produto = update)"
        />
        <CenarioInput
          class="avancado-input"
          placeholder="Digite a NCM"
          nome="Ncm"
          :model="ncm"
          :options="ncmOptions"
          :disabled="form.nome_produto != '' ? true : false"
          @update:model="update => (ncm = update)"
          @selected="update => (form.ncm = update)"
        />
        <CenarioInput
          class="avancado-input"
          placeholder="Selecione a UF"
          nome="UF"
          :model="uf"
          :options="ufOptions"
          @update:model="update => (uf = update)"
          @selected="update => (form.uf = update)"
        />
        <CenarioInput
          class="avancado-input"
          placeholder="Selecione o Tributo"
          nome="tributo"
          :model="tributo"
          :options="tiposTributacao"
          @update:model="update => (tributo = update)"
          @selected="update => (form.tributo = update)"
        />
      </div>
    </transition>
    <ModalRelatorio :alteracoes="filtro" :form="form"></ModalRelatorio>
  </div>
</template>

<script>
import stringFormatMixin from "@/mixins/stringFormatMixin";
import form from "bootstrap-vue/es/components/form";
import Datepicker from "vuejs-datepicker";
import { mapGetters } from "vuex";
import Api from "@/services/api.js";
import pt from "vuejs-datepicker/dist/locale/translations/pt-BR";
import CenarioInput from "../CenarioInput/CenarioInput.vue";
import ModalRelatorio from "../ModalRelatorio/ModalRelatorio.vue";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";

export default {
  name: "FiltrosMonitoria",
  props: {
    impressaoPdf: Function,
    conteudo: Array,
    data_de: String,
    data_ate: String
  },
  components: {
    Datepicker,
    CenarioInput,
    ModalRelatorio,
    BotaoPadrao
  },
  mixins: [stringFormatMixin],
  data() {
    return {
      pt: pt,
      strPesquisa: "",
      tiposTributacao: [],
      ncmOptions: [],
      ufOptions: [],
      produto: [],
      selecao: "",
      nomeProduto: "",
      ncm: "",
      uf: "",
      tributo: "",
      form: {
        nome_produto: "",
        de: "",
        ate: "",
        uf: "",
        ncm: "",
        tributo: "",
        id_arquivo: "",
        cest: ""
      },
      filtro: [],
      blFiltros: false,
      arquivo_id: [],
      de: "",
      ate: "",
      defaultDe: "",
      defaultAte: "",
      desabilitar: false
    };
  },
  created() {
    if (this.data_de && this.data_ate) {
      this.de = this.converterData(this.data_de);
      this.ate = this.converterData(this.data_ate);
    }
  },

  mounted() {
    this.retornaItens();
  },
  watch: {
    produtosFiltrados() {},
    de() {
      if (this.de && this.de != "" && typeof this.de != "string") {
        this.form.de = this.formatDateValue(this.de);
      } else {
        this.form.de = "";
      }
    },

    ate() {
      if (this.ate && this.ate != "" && typeof this.ate != "string") {
        this.form.ate = this.formatDateValue(this.ate);
      } else {
        this.form.ate = "";
      }
    }
  },
  computed: {
    ...mapGetters("empresa", {
      getEmpresa: "getEmpresa"
    }),
    produtosFiltrados: function() {
      if (this.strPesquisa != "") {
        this.filtro = this.conteudo.filter(
          f =>
            this.removerAcentos(f.nome_produto.toLowerCase()).includes(
              this.removerAcentos(this.strPesquisa.toLowerCase())
            ) ||
            f.ncm_produto
              .toLowerCase()
              .replaceAll(".", "")
              .includes(this.strPesquisa.toLowerCase().replaceAll(".", "")) ||
            this.removerAcentos(f.ncm_produto.toLowerCase()).includes(
              this.removerAcentos(this.strPesquisa.toLowerCase())
            ) ||
            f.descricao
              .toLowerCase()
              .includes(this.strPesquisa.toLowerCase().replaceAll(".", "")) ||
            this.removerAcentos(f.descricao.toLowerCase()).includes(
              this.removerAcentos(this.strPesquisa.toLowerCase())
            ) ||
            f.data_alteracao
              .toLowerCase()
              .includes(this.strPesquisa.toLowerCase().replaceAll(".", "")) ||
            this.removerAcentos(f.data_alteracao.toLowerCase()).includes(
              this.removerAcentos(this.strPesquisa.toLowerCase())
            ) ||
            f.tipo_tributacao
              .toLowerCase()
              .includes(this.strPesquisa.toLowerCase().replaceAll(".", "")) ||
            this.removerAcentos(f.tipo_tributacao.toLowerCase()).includes(
              this.removerAcentos(this.strPesquisa.toLowerCase())
            ) ||
            f.estado_mudanca
              .toLowerCase()
              .includes(this.strPesquisa.toLowerCase().replaceAll(".", "")) ||
            this.removerAcentos(f.estado_mudanca.toLowerCase()).includes(
              this.removerAcentos(this.strPesquisa.toLowerCase())
            ) ||
            f.data_efeito
              .toLowerCase()
              .includes(this.strPesquisa.toLowerCase().replaceAll(".", "")) ||
            this.removerAcentos(f.data_efeito.toLowerCase()).includes(
              this.removerAcentos(this.strPesquisa.toLowerCase())
            )
        );
        this.$emit("produtosFiltradosAtualizados", this.filtro);
        return this.filtro;
      } else if (
        this.form.ncm != "" ||
        this.form.uf != "" ||
        this.form.tributo != "" ||
        this.form.nome_produto != "" ||
        (this.de != "" && this.ate != "")
      ) {
        this.filtro = this.conteudo;
        if (this.form.ncm != "") {
          this.filtro = this.filtro.filter(f => f.ncm_produto == this.form.ncm);
          this.$emit("produtosFiltradosAtualizados", this.filtro);
        }
        if (this.form.uf != "") {
          this.filtro = this.filtro.filter(f => f.estado_mudanca == this.form.uf);
          this.$emit("produtosFiltradosAtualizados", this.filtro);
        }
        if (this.form.tributo != "") {
          this.filtro = this.filtro.filter(f => f.tipo_tributacao == this.form.tributo);
          this.$emit("produtosFiltradosAtualizados", this.filtro);
        }
        if (this.form.nome_produto != "") {
          this.filtro = this.filtro.filter(f => f.nome_produto == this.form.nome_produto);
          this.$emit("produtosFiltradosAtualizados", this.filtro);
        }
        if (this.de != "" && this.ate != "") {
          let startDate = this.formatDateValue(this.de);
          let endDate = this.formatDateValue(this.ate);
          let temp = this.converterData(startDate);
          let temp2 = this.converterData(endDate);
          startDate = new Date(temp);
          endDate = new Date(temp2);
          let that = this;

          this.filtro = this.filtro.filter(function(alteracao) {
            const data = that.converterData(alteracao.data_alteracao);
            let dataAlteracao = new Date(data);
            return dataAlteracao >= startDate && dataAlteracao <= endDate;
          });

          // filtroAvancado = filtroAvancado.filter(f => f.nome_produto == this.nome_produto);
          this.$emit("produtosFiltradosAtualizados", this.filtro);
        }
      } else {
        this.filtro = this.conteudo;
        this.$emit("produtosFiltradosAtualizados", this.filtro);
      }
    },
    disabledDatesAfterDe() {
      // Desativa as datas depois de `form.ate` ou datas antes de hoje
      const disabledDates = {
        to: this.de ? new Date(this.de) : null,
        from: this.de ? new Date() : new Date()
      };

      // Adiciona a data selecionada em "Até" como a data máxima (`to`) que pode ser selecionada em "De"
      if (this.ate) {
        disabledDates.from = new Date(Math.min(disabledDates.from, new Date(this.ate)));
      }

      return disabledDates;
    },
    disabledDatesBeforeAte() {
      // Desativa as datas antes de `form.de` ou datas após a data atual
      return {
        to: this.de ? new Date(this.de) : null,
        from: this.de ? new Date() : new Date()
      };
    }
  },

  methods: {

    openModalRelatorio() {
      this.$root.$emit("bv::show::modal", "ModalRelatorio");
    },
    clearDe() {
      this.de = "";
      this.ate = "";
    },
    formatDateValue(date) {
      const day = date
        .getDate()
        .toString()
        .padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear().toString();
      return `${day}/${month}/${year}`;
    },
    abreFiltros() {
      this.blFiltros = !this.blFiltros;
    },
    retornaItens() {
      const tiposTributacao = [...new Set(this.conteudo.map(p => p.tipo_tributacao))];
      this.tiposTributacao = tiposTributacao.sort((a, b) => {
        if (a == "-" || a == "" || a == "0" || b == "-" || b == "" || b == "0") {
          return a == "-" || a == "" || a == "0" ? -1 : 1;
        }
        return a.localeCompare(b);
      });

      const ncm = [...new Set(this.conteudo.map(p => p.ncm_produto))];
      this.ncmOptions = ncm.sort((a, b) => {
        if (a == "-" || a == "" || a == "0" || b == "-" || b == "" || b == "0") {
          return a == "-" || a == "" || a == "0" ? -1 : 1;
        }
        return a.localeCompare(b);
      });

      const uf = [...new Set(this.conteudo.map(p => p.estado_mudanca))];
      this.ufOptions = uf.sort((a, b) => {
        if (a == "-" || a == "" || a == "0" || b == "-" || b == "" || b == "0") {
          return a == "-" || a == "" || a == "0" ? -1 : 1;
        }
        return a.localeCompare(b);
      });

      const nome_produto = [...new Set(this.conteudo.map(p => p.nome_produto))];
      this.produto = nome_produto.sort((a, b) => {
        if (a == "-" || a == "" || a == "0" || b == "-" || b == "" || b == "0") {
          return a == "-" || a == "" || a == "0" ? -1 : 1;
        }
        return a.localeCompare(b);
      });
    },

    converterData(data) {
      // Separa a data em dia, mês e ano
      if (data && data != "") {
        const [dia, mes, ano] = data.split("/");

        // Retorna a data no formato "mm/dd/yyyy"
        return `${mes}/${dia}/${ano}`;
      } else {
        return null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form-filtros {
  //   border: 1px solid var(--preto);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  i {
    margin-right: 5px;
  }
}
.input-filtros {
  border-radius: 1px;
  border: 1px solid rgba(60, 60, 60, 0.26);
  box-shadow: 2px 2px 4px #00000010;
  color: #333;
  background: #fdfdfd;
  padding: 5px;
  transition: all 0.3s ease;
  margin: 5px;
  height: 30px;
  width: 100%;
  &:focus {
    border: 1px solid #079eda;
  }
}
.vdp-datepicker {
  margin: 0 0 0 5px;
}
.input-pesquisar {
  border-radius: 2px;
  // border: 1px solid rgba(60, 60, 60, 0.26);
  color: #333;
  background: #fdfdfd;
  // padding: 5px;
  transition: all 0.3s ease;
  // margin: 5px;
  // height: 30px;
  width: 100%;
}
.intervalo-tempo {
  display: flex;
  padding: 10px 0;
  margin-left: 10px;
  align-items: center;
}

.pesquisar-btn {
  border-radius: 2px;
  background: #06496d;
  padding: 4px 9px;
  color: #fdfdfd;
}

.btn-form-filtros-avancados {
  // padding: 0 40px;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: flex-end;
  user-select: none;
  p {
    margin-bottom: 0;
    text-decoration: underline;
    cursor: pointer;
  }
}
.icon-filter {
  margin: 0 15px 0 5px;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.2s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.form-filtros-avancados {
  // border: 1px solid var(--preto);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0 0 0 13px;
}
.avancado-input {
  border-radius: 2px;
  // border: 1px solid rgba(60, 60, 60, 0.26);
  color: #333;
  background: #fdfdfd;
  // padding: 5px;
  // transition: all 0.3s ease;
  margin: 0 0px 20px 5px;
  height: 30px;
  width: 100%;
}

.input-disabled {
  background-color: #f5f5f5;
  color: #888;
  cursor: not-allowed;
  border-radius: 2px;
  border: 1px solid rgba(60, 60, 60, 0.26);
  color: #333;
  padding: 5px;
  transition: all 0.3s ease;
  margin: 5px;
  height: 30px;
  width: 100%;
}
.btn-limpar {
  border-radius: 2px;
  background-color: #999;
  color: var(--branco);
  font-weight: bold;
  padding: 4px 9px;
  margin-left: 5px;
}
.btn-monitoria {
  color: var(--branco);
  border-radius: 2px;
  font-size: 14px;
  font-weight: normal;
  border: 0;
  span {
    padding: 4px 10px;
    font-family: Roboto Condensed;
    background: var(--azul2);
    display: inline-block;
    border-radius: 50px 0 0 50px;
  }
  i {
    background-color: #06496d;
    padding: 4px 5px 6px 5px;
    border-radius: 0 2px 2px 0;
  }
}

.nav-link-monitoria {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  padding: 0;
}
.botao-relatorio-container {
  display: flex;
}
.icone-botao {
  width: 17px;
}
</style>
